export default {
  admin: 'አስተዳዳሪ',
  password: {
    enterNewPassword: 'አዲስ የይለፍ ቃል ያስገቡ',
    reenterNewPassword: 'አዲሱን የይለፍ ቃል እንደገና ያስገቡ',
    updatePassword: 'የይለፍ ቃል አዘምን',
    setPassword: 'የይለፍ ቃል አዘጋጅ',
    min8CharacterMessage: 'የይለፍ ቃል ቢያንስ 8 ቁምፊዎች መኖር አለበት',
    passwordSentMessage: 'የይለፍ ቃል በኢሜል ወደ {userName} ተልኳል።',
    generateNewPassword: 'አዲስ የይለፍ ቃል ፍጠር',
    assignPasswordMessage: 'ለተጠቃሚው የይለፍ ቃል ይመድቡ። ተጠቃሚው በሚቀጥለው ግባት ይህንን የይለፍ ቃል መቀየር ይኖርበታል።',
    generateSecurePassword: 'ደህንነቱ የተጠበቀ የይለፍ ቃል ፍጠር',
    newPassword: 'አዲስ የይለፍ ቃል',
    confirmNewPassword: 'አዲሱን የይለፍ ቃል ያረጋግጡ',
    passwordHistory: 'የይለፍ ቃል ታሪክ',
    passwordUpdatedLog: 'የይለፍ ቃል በ{userName} በ{date} ተዘምኗል።',
    forgotPasswordLog: 'የይለፍ ቃል መርሳት ጥያቄ በ{userName} በ{date} ተላከ።',
  },
};
